import { useState } from "react";
import { Divider } from "../../../common/Divider";
import "./practice-response-modal-body.scss";
import { decodeJWTToken } from "../../../utils/commonUtilities";

export const PracticeResponse = ({
  onSubmitCallback,
  patientReview,
  onClose,
  responseName,
  responseComment,
}) => {
  const [data, setData] = useState(() => {
    const userDetails = decodeJWTToken(localStorage.getItem("auth-key"));

    return {
      responseName: responseName ?? null,
      responseComment: responseComment ?? null,
      surveyDisplayId: patientReview.surveyDisplayId,
      userDisplayId: userDetails?.user?.displayId,
    };
  });

  return (
    <div className="respond-review-aside">
      <p className="policy">
        Brighter allows providers to publicly respond to patient reviews. Your
        response will be published alongside the patient’s review on your
        directory profile after an internal review by Brighter. Prospective
        patients will pay as much attention to the tone and tenor of your
        response as to any patient review - be sure to respond in a constructive
        manner.
      </p>
      <Divider />
      <div className="middle">
        <div className="review-details">
          {patientReview.isRecommended ? (
            <>
              <i className="bi bi-hand-thumbs-up"></i>
              <strong>Recommended</strong> - Verified Patient
            </>
          ) : (
            <>
              <i className="bi bi-hand-thumbs-down"></i>
              <strong>Not Recommended</strong> - Verified Patient
            </>
          )}

          <div className="review-date">
            <strong>Reviewed on: </strong> {patientReview.date}
          </div>
        </div>

        <p className="comment">“{patientReview.review}”</p>

        <h5>Practice Location: </h5>
        {patientReview?.practiceCityState && patientReview?.practiceStreet1 ? (
          <address>
            {patientReview?.practiceStreet1},{patientReview?.practiceCityState}
          </address>
        ) : null}
      </div>
      <Divider />
      <div className="bottom">
        <form name="responseForm">
          <h3>Enter your response</h3>
          <textarea
            required
            value={data.responseComment}
            onChange={(e) => {
              e.preventDefault();
              setData((prev) => ({
                ...prev,
                responseComment: e.target.value,
              }));
            }}
          ></textarea>
          <h3>Your First Name</h3>
          <input
            type="text"
            required
            value={data.responseName}
            onChange={(e) => {
              e.preventDefault();
              setData((prev) => ({
                ...prev,
                responseName: e.target.value,
              }));
            }}
          ></input>
          <div className="bottom-footer">
            <button
              className="primary btn btn-outline-secondary"
              disabled={!data.responseName || !data.responseComment}
              onClick={() => {
                onSubmitCallback(data);
              }}
            >
              Submit
            </button>
            <button
              className="secondary btn btn-outline-secondary"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
        </form>
        <div className="tips-box">
          <h5>Tips on writing a good response</h5>
          <ul>
            <li>
              Do not include any patient's medical or diagnostic information
            </li>
            <li>Do not include any patient identifying information</li>
            <li>
              A positive and polite response reflects well on your practice
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
